import { stringify } from 'qs';

export function stringifyQueryString(params?: object | null): string {
    return stringify(params ?? {}, { arrayFormat: 'indices', skipNulls: true });
}

export const randomString = (length: number = 6): string => {
    return [...Array(length)].map(() => Math.random().toString(36)[2]).join('');
};

export const countryEmoji = (isoCountry: string): string => {
    return isoCountry
        .toUpperCase()
        .split('')
        .map((char) => String.fromCodePoint(char.charCodeAt(0) + 0x1f1a5))
        .join('');
};

export const firstToUpperCase = (string: unknown): string => {
    if (typeof string !== 'string') {
        throw new Error(`Provided value "${string}" is not a valid string`);
    }

    return String(string).charAt(0).toUpperCase() + String(string).slice(1);
};

export const disambiguateName = (desired: string, isTaken: (name: string) => boolean, maxLength: number): string => {
    if (!isTaken(desired)) {
        return desired;
    }

    const characters = Array.from(desired);
    const withSuffix = (suffix: string): string =>
        `${characters
            .slice(0, maxLength - suffix.length)
            .join('')
            .trimEnd()}${suffix}`;

    let candidate = withSuffix(' Copy');
    let counter = 2;

    while (isTaken(candidate)) {
        candidate = withSuffix(` Copy ${counter}`);
        counter += 1;
    }

    return candidate;
};

export const isNotEmpty = (string: unknown): boolean => {
    return typeof string === 'string' && string.trim() !== '';
};

export const isUrl = (value: string): boolean => {
    try {
        const { protocol } = new URL(value);
        return protocol === 'http:' || protocol === 'https:';
    } catch {
        return false;
    }
};

export const humanize = (raw: string): string =>
    raw.replace(/[_-]+/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
